import React from 'react';
import classNames from 'classnames';

import './CloseButton.scss';

interface CloseButtonProps {
  ariaLabel: string;
  options: {
    withShadow: boolean, // Disabled / enables circle with shadow on close btn
    inverse: boolean // inverse color of button
    inverseOnlyMobile: boolean
  };
  onClick(): void;
}

const CloseButton = (
    {
      ariaLabel = '',
      onClick = () => true,
      options = {
        withShadow: true,
        inverse: false,
        inverseOnlyMobile: false
      }
    }: CloseButtonProps) => {
    return (
      <button
        styleName={classNames({
          close__btn: true,
          'close__btn--with-shadow': options.withShadow,
          'close__btn--inverse': options.inverse,
          'close__btn--inverse-mobile-only': options.inverseOnlyMobile
        })}
        type="button"
        aria-label={ariaLabel}
        onClick={onClick}
      />
    );
};

export default CloseButton;
